import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { ClinicalDocumentListComponent } from 'app/integration/document/containers/clinical-document-list.component';
import { Routes } from '@angular/router';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PatientLibModule } from 'app/mpi/lib/patient/patient-lib.module';
import { DocumentLibModule } from './document-lib.module';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';
import { AmbulanceCardListComponent } from 'app/integration/document/ambulance-card/containers/ambulance-card-list.component';
import { OrganizationLibModule } from 'app/mdm/lib/organization/organization-lib.module';
import { EConsultationListComponent } from 'app/integration/document/e-referrals/e-consultation-list.component';
import { EConsultationResponseComponent } from 'app/integration/document/e-referrals/e-consultation-response.component';
import { PractitionerLibModule } from 'app/mdm/lib/practitioner/practitioner-lib.module';
import { ClinicalDocumentViewComponent } from 'app/integration/document/containers/clinical-document-view.component';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { HealthcareContextModule } from 'app/reception/lib/healthcare-context/healthcare-context.module';
import { ResponseReferralDetailsComponent } from 'app/integration/document/e-referrals/response-referral-details.component';

export const DOCS_ROUTES: Routes = [
  { path: '', component: ClinicalDocumentListComponent },
  { path: 'view', component: ClinicalDocumentViewComponent },
  { path: 'ambulance-cards', component: AmbulanceCardListComponent },
  { path: 'e-consultations', component: EConsultationListComponent },
  { path: 'e-consultations/response', component: EConsultationResponseComponent }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    HedaCoreUtilModule,
    HedaCoreHospitalUiModule,
    TerminologyLibModule,
    FormsModule,
    DocumentLibModule,
    PatientLibModule,
    OrganizationLibModule,
    PractitionerLibModule,
    NzTypographyModule,
    HealthcareContextModule
  ],
  exports: [ResponseReferralDetailsComponent],
  declarations: [
    ClinicalDocumentListComponent,
    AmbulanceCardListComponent,
    EConsultationListComponent,
    EConsultationResponseComponent,
    ClinicalDocumentViewComponent,
    ResponseReferralDetailsComponent
  ]
})
export class DocumentModule {}
